import { FormField, Radio, RadioGroup } from 'taboola-ultimate-ui';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { PLATFORMS } from '../../config';
import { MobileInventoryTargetingTooltip } from './MobileInventoryTargetingTooltip';
import { MOBILE_INVENTORY_TARGETING } from './mobileInventoryTargetingConsts';
import styles from './mobileInventoryTargeting.module.scss';

const isDesktopOnlyTargeted = platformTargeting =>
    platformTargeting?.length === 1 && platformTargeting?.[0] === PLATFORMS.DESKTOP;

export const MobileInventoryTargeting = () => {
    const { value: mobileInventoryTargeting, onChange: onMobileInventoryTargetingChange } = useFormFieldValue({
        field: 'mobileInventoryTargeting',
    });
    const { value: platformTargeting } = useFormFieldValue({ field: 'platformTargeting' });

    const isDisabled = isDesktopOnlyTargeted(platformTargeting);

    return (
        <FormField
            containerClass={styles['input']}
            label={
                <FormattedMessage
                    id="campaign.editor.mobileAppTrafficTargeting.label"
                    defaultMessage="Mobile Inventory"
                />
            }
            description={
                <FormattedMessage
                    id="campaign.editor.mobileAppTrafficTargeting.description"
                    defaultMessage="Select the type of mobile traffic you want to target to optimize your campaign performance."
                />
            }
            helpText={<MobileInventoryTargetingTooltip />}
        >
            <RadioGroup
                name="mobileInventoryTargeting"
                selectedValue={mobileInventoryTargeting}
                onChange={onMobileInventoryTargetingChange}
                className={styles['radio-group']}
                disabled={isDisabled}
                data-testid="mobile-inventory-targeting-radio-group"
            >
                <Radio
                    value={MOBILE_INVENTORY_TARGETING.ALL}
                    title={<FormattedMessage id="campaign.editor.mobileAppTrafficTargeting.all" defaultMessage="All" />}
                />
                <Radio
                    value={MOBILE_INVENTORY_TARGETING.MOBILE_WEB}
                    title={
                        <FormattedMessage
                            id="campaign.editor.mobileAppTrafficTargeting.mobileWeb"
                            defaultMessage="Mobile Web"
                        />
                    }
                />
                <Radio
                    value={MOBILE_INVENTORY_TARGETING.MOBILE_APP}
                    title={
                        <FormattedMessage
                            id="campaign.editor.mobileAppTrafficTargeting.mobileApp"
                            defaultMessage="Mobile Apps"
                        />
                    }
                />
            </RadioGroup>
        </FormField>
    );
};
